// extracted by mini-css-extract-plugin
export var actionText = "_qz-4";
export var container = "_qz-0";
export var leftSection = "_qz-1";
export var rightSection = "_qz-2";
export var settingsButton = "_qz-6";
export var settingsIcon = "_qz-7";
export var shortcut = "_qz-5";
export var shortcutGroup = "_qz-3";